<template>
  <div
    id="btn"
    :style="style"
    :class="{'w-100': full}"
    class="d-flex align-items-center justify-content-center font-weight-bold text-center cursor-pointer py-1 px-2"
    @mouseenter="mouseInEvent"
    @mouseleave="mouseOutEvent"
    @click="emit"
  >
    <slot name="icon" />
    <span
      v-if="!mouseIn"
      class="btn-text"
    >{{ title }}</span>
    <span
      v-else
      class="btn-text"
    >{{ hoverText === "" ? title : hoverText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String,
    },
    hoverText: {
      required: false,
      type: String,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    full: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      mouseIn: false,
    }
  },
  computed: {
    style() {
      let back = ''
      let color = ''
      switch (this.color) {
        case 'primary':
          back = '#142B6F'
          color = '#FFFFFF'
          break
        case 'primary-white':
          back = '#FFFFFF'
          color = '#142B6F'
          break
        case 'primary-dark':
          back = '#B5CBFC'
          color = '#0A6ECA'
          break
        case 'warning':
          back = '#FDDBB9'
          color = '#F07921'
          break
        case 'danger':
          back = 'rgba(220,53,69, 0.2)'
          color = '#dc3545'
          break
        case 'success':
          back = '#0D7257'
          color = '#28a745'
          break
        case 'info':
          back = 'rgb(102,16,242, 0.2)'
          color = '#6610f2'
          break
        default:
          back = '#142B6F'
          color = '#FFFFFF'
          break
      }
      if (!this.mouseIn) return `background-color: ${back}; color: ${color}`
      return `background-color: ${color}; color: ${back}`
    },
  },
  methods: {
    mouseInEvent() {
      this.mouseIn = true
    },
    mouseOutEvent() {
      if (this.mouseIn) this.mouseIn = !this.mouseIn
    },
    emit() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
#btn {
  border-radius: 10px;
  font-size: 1em;
  transition: all 0.5s ease;
  border: solid;
  border-width: 1px;
  border-radius: 8px;
}
.btn-text {
  text-align: left;
  font-size: var(--dashboard-default-font-size);
  font-weight: 400;
  letter-spacing: 0px;
  opacity: 1;
}
</style>
